import { useMemo, useState } from "react";
import Viewer from "react-viewer";
import {
  convertStringToArray,
  getLatestDateFromData,
} from "../../../Utils/utils";
import Loader from "../../../components/Loader";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import PdfZipItem from "../../../components/PdfZipItem";
import { imageUrl } from "../../../constants/constants";

const MedicalCSR = () => {
  const { getText } = useLanguageTranslation();

  const [visible, setVisible] = useState(false);
  const { languageType } = useSelector((state) => state.homeSlice);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const { data: medicalData = [], isLoading: medicalIsLoading } =
    useGetProtectedApiDataQuery({
      url: "_medical_health_care_and_sanitation",
      lang: languageType,
    });

  const transformedData = medicalData.map((item) => ({
    ...item,
    images: convertStringToArray(item.field_events_image),
    pdfs: convertStringToArray(item.field_medical_healthcare_file),
  }));

  const healthCarePdfData = transformedData[3];

  // console.log({ healthCarePdfData });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(transformedData);
  }, [transformedData]);

  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: imageUrl + img.file_path,
        alt: img.title,
      })),
    );
    setActiveIndex(index);
    setVisible(true);
  };

  if (medicalIsLoading) {
    return (
      <div className="csr-loader">
        <Loader />;
      </div>
    );
  }

  return (
    <>
      <h2 className="title2">
        <p dangerouslySetInnerHTML={{ __html: medicalData[3]?.title }}></p>
      </h2>
      <div className="container">
        <div className="table-responsive mb-5">
          <table className="table table-striped custom-table">
            <thead className="thead-dark">
              <tr>
                <th>{getText("S.No.", "क्र. सं.")}</th>
                <th>{getText("Title", "शीर्षक")}</th>
                <th>{getText("Detail", "विवरण")}</th>
              </tr>
            </thead>
            <tbody>
              {healthCarePdfData?.pdfs.map((item, index) => (
                <tr key={index}>
                  <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                  <td data-key={getText("Title", "शीर्षक")}>{item.title}</td>
                  <td data-key={getText("Detail", "विवरण")}>
                    <PdfZipItem filePath={item?.file_path} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {transformedData.slice(0, 3).map((galleryItem, index) => (
          <div className="row" key={index}>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
              <div className="title-sec mb-2">
                <h2>{galleryItem.title}</h2>
              </div>
            </div>
            {galleryItem.images.length > 0 &&
              galleryItem.images.map((item, subIndex) => (
                <div
                  className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4 print-gallery3"
                  key={subIndex}
                  onClick={() => openViewer(galleryItem.images, subIndex)}
                >
                  <div className="card-sec wow zoomIn">
                    <div className="img-sec">
                      <img
                        alt={
                          item.title ||
                          getText("CSR activity photo", "सीएसआर गतिविधि की फोटो")
                        }
                        src={imageUrl + item.file_path}
                      />
                    </div>
                    <div className="desc-sec csr-gallery-desc">
                      <div className="title-sec">
                        <h2>
                          <a href="javascript:void(0)">
                            {item.title.length > 50
                              ? `${item.title.slice(0, 100)} .....`
                              : item.title}
                          </a>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
      <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
};

export default MedicalCSR;
